import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { error, warning } from "../Components/custom-toast/CustomToast";
import { splitAddress } from "./api-service";

export const HandleVersa = (value, set) => {
  set(!value);
};

export const ValidateEmail = (email) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  if (!regex.test(email)) {
    return false;
  }
  return true;
};

export const getSizeWindows = () => {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [window]);
  return windowSize;
};

export function toNonAccentVietnamese(str) {
  str = str.replace(/A|Á|À|Ã|Ạ|Â|Ấ|Ầ|Ẫ|Ậ|Ă|Ắ|Ằ|Ẵ|Ặ/g, "A");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/E|É|È|Ẽ|Ẹ|Ê|Ế|Ề|Ễ|Ệ/, "E");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/I|Í|Ì|Ĩ|Ị/g, "I");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/O|Ó|Ò|Õ|Ọ|Ô|Ố|Ồ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ỡ|Ợ/g, "O");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/U|Ú|Ù|Ũ|Ụ|Ư|Ứ|Ừ|Ữ|Ự/g, "U");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/Y|Ý|Ỳ|Ỹ|Ỵ/g, "Y");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/Đ/g, "D");
  str = str.replace(/đ/g, "d");
  str = str.replace(/`|~/g, "");
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
  return Date.now().toString() + "_" + stringToSlug(str);
}

export const numberOnly = (value) => {
  if (!isNaN(value)) return value;
  return "";
};

//check value exist
export const isNullOrEmpty = (value) => {
  if (value === undefined || value === "" || value === null) {
    return true;
  }
  return false;
};

export const isEmptyObj = (obj) => {
  return obj && typeof obj === 'object' && Object.keys(obj).length === 0;
}

export const ConvertDateJS = (convertDate) => {
  // new Date() (in Reactjs)
  var date = new Date(convertDate.$d);
  const result =
    date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
  return result;
};

export function ConvertDate(str) {
  //date() (in html && spring)
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [day, mnth, date.getFullYear()].join("-");
}

export const openInNewTab = (url) => {
  window.open(url, "_blank", "noreferrer");
};

export const navigateToNewTabExternal = (url) => {
  window.location.href = url;
};

export const moneyFormat = (money) => {
  const formattedNumber = money
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return formattedNumber;
};

export const countTimeExpired = (objectDto, setObjectDto) => {
  const navigation = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || !objectDto) {
      LogOut(setObjectDto);
      navigation("/");
      return;
    }
    const tokenExp = JSON.parse(token);
    const checkTokenExpiration = () => {
      const currentDateTime = new Date();
      const year = currentDateTime.getFullYear();
      const month = ("0" + (currentDateTime.getMonth() + 1)).slice(-2);
      const day = ("0" + currentDateTime.getDate()).slice(-2);
      const hours = ("0" + currentDateTime.getHours()).slice(-2);
      const minutes = ("0" + currentDateTime.getMinutes()).slice(-2);
      const seconds = ("0" + currentDateTime.getSeconds()).slice(-2);
      const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}`;
      if (timestamp > tokenExp.exprDate) {
        alert("Hết hạn kết nối đến server, vui lòng đăng nhập lại để tiếp tục");
        navigation("/");
        window.location.reload();
      }
    };
    const interval = setInterval(() => {
      checkTokenExpiration();
    }, 1000);
    return () => clearInterval(interval);
  }, []);
};

export const handleOpenPDF = (base64String) => {
  const base64 = base64String.replace(/^data:application\/pdf;base64,/, "");
  const byteCharacters = atob(base64);
  const byteNumbers = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const blob = new Blob([byteNumbers], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);
  openInNewTab(blobUrl);
};

export function stringToSlug(str) {
  return str
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}

export const ValidatePhone = (phone) => {
  const regex = /^(0[3-9]{1}[0-9]{8})$/;
  if (!regex.test(phone)) {
    return false;
  }
  return true;
};

export const SetValueETargetValue = (value, setValue) => {
  if (!isNullOrEmpty(value)) setValue(value);
  else setValue("");
};

export const calculateAge = (dateOfBirth) => {
  const dob = new Date(dateOfBirth);
  const now = new Date();

  let age = now.getFullYear() - dob.getFullYear();
  const hasBirthdayPassed =
    now.getMonth() > dob.getMonth() ||
    (now.getMonth() === dob.getMonth() && now.getDate() >= dob.getDate());

  if (!hasBirthdayPassed) {
    age--;
  }

  return age;
};

export const isObjectValid = (objectDto, imgBack, imgFront, setObjectDto) => {
  if(isNullOrEmpty(objectDto.fullName)) return false;
  if(isNullOrEmpty(objectDto.dob)) return false;
  if(isNullOrEmpty(objectDto.gender)) return false;
  if(isNullOrEmpty(objectDto.phoneNumber)) return false;
  if(isNullOrEmpty(objectDto.birthPlace)) return false;
  if(isNullOrEmpty(objectDto.married)) return false;
  if(isNullOrEmpty(objectDto.occupationId)) return false;
  if(isNullOrEmpty(objectDto.idnumber)) return false;
  if(isNullOrEmpty(objectDto.iddate)) return false;
  if(isNullOrEmpty(objectDto.idplace)) return false;
  if(isNullOrEmpty(objectDto.email)) return false;
  if(isNullOrEmpty(objectDto.provinceCode)) return false;
  // if(isNullOrEmpty(objectDto.districtCode)) return false;
  if(isNullOrEmpty(objectDto.wardCode)) return false;
  if(isNullOrEmpty(objectDto.address)) return false;
  if(isNullOrEmpty(objectDto.contactProvinceCode)) return false;
  // if(isNullOrEmpty(objectDto.contactDistrictCode)) return false;
  if(isNullOrEmpty(objectDto.contactWardCode)) return false;
  if(isNullOrEmpty(objectDto.contactAddress)) return false; 
  if(isNullOrEmpty(imgFront)) return false;
  if(isNullOrEmpty(imgBack)) return false;
  splitAddress(objectDto, setObjectDto);
  return true;
};

export const removeDotFromStringMoney = (money) => {
  var list = money.split(".");
  return moneyFormat(list[0]);
};

export const formatDateToDDMMYYYY = (date) => {
  if (!date || isNaN(date.getTime())) return null; // Handle invalid date
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is 0-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export function getRemainingSeconds(fullStr) {
  const timePart = fullStr.split(" ")[1];

  const [hours, minutes, msWithSeconds] = timePart.split(":");
  const seconds = Math.floor(Number(msWithSeconds) / 1000);
  const now = new Date();
  const baseTime = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    Number(hours),
    Number(minutes),
    seconds
  );
  const targetTime = new Date(baseTime.getTime() + 5 * 60 * 1000);

  const diffMs = targetTime - now;

  return diffMs > 0 ? Math.floor(diffMs / 1000) : 0;
}

export function formatYYYYMMDDToDDMMYYYY(dateString) {
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
}

export const openBase64Pdf = (base64String, fileName) => {
  try {
    if (!base64String || typeof base64String !== 'string') {
      throw new Error('File đang được xử lí vui lòng thử lại sau');
    }
    const cleanedBase64 = base64String.replace(/^data:application\/pdf;base64,/, '');
    const base64Pattern = /^[A-Za-z0-9+/=]+$/;
    if (!base64Pattern.test(cleanedBase64)) {
      throw new Error('File đang được xử lí vui lòng thử lại sau');
    }
    const byteCharacters = atob(cleanedBase64);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const newTab = window.open(blobUrl, "_blank");
    if (newTab) {
      newTab.focus();
    } else {
      throw new Error('Vui lòng cấu hình trình duyệt cho phép mở trang mới.');
    }
  } catch (err) {
      error(`Mở file thất bại: ${err.message}`);
  }
};

export const detectAndFormatBase64Image = (base64) => {
  if (!base64 || typeof base64 !== "string") return "";
  const signatures = {
    jpeg: "/9j/", 
    png: "iVBORw0KGgo",
    gif: "R0lGOD",
    bmp: "Qk", 
    webp: "UklGR", 
  };
  let imageType = "jpeg"; 
  for (const [type, signature] of Object.entries(signatures)) {
    if (base64.startsWith(signature)) {
      imageType = type;
      break;
    }
  }
  return `data:image/${imageType};base64,${base64}`;
};
export const countVietnameseChars = (str) => {
  const decomposed = str.normalize('NFD');
  return [...decomposed].length > 60;
};

export const hidePhoneNumber = (phone) => {
  if(phone === undefined || phone.length < 6) return phone;
  const first = phone.slice(0, 3);
  const last = phone.slice(-3);
  const masked = "X".repeat(phone.length - 6);

  return first + masked + last;
}
export const isValidAddress = (address) => {
  if (isNullOrEmpty(address)) return false;
  const trimmedAddress = address.trim();
  return /\s+/.test(trimmedAddress);
};
